import { createSelector } from 'redux-orm';

import orm from '../orm';
import getMeta from '../utils/get-meta';
import { isLocalId } from '../utils/local-id';

export const makeSelectListById = () =>
  createSelector(
    orm,
    (_, id) => id,
    ({ List }, id) => {
      const listModel = List.withId(id);

      if (!listModel) {
        return listModel;
      }

      return {
        ...listModel.ref,
        ...getMeta(listModel),
        isPersisted: !isLocalId(id),
      };
    },
  );

export const selectListById = makeSelectListById();

export const makeSelectCardIdsByListId = () =>
  createSelector(
    orm,
    (_, id) => id,
    ({ List }, id) => {
      const listModel = List.withId(id);

      if (!listModel) {
        return listModel;
      }

      return listModel.getOrderedCardsModelArray().map((cardModel) => cardModel.id);
    },
  );

export const selectCardIdsByListId = makeSelectCardIdsByListId();

export const makeSelectIsFilteredByListId = () =>
  createSelector(
    orm,
    (_, id) => id,
    ({ List }, id) => {
      const listModel = List.withId(id);

      if (!listModel) {
        return listModel;
      }

      return listModel.getIsFiltered();
    },
  );

export const selectIsFilteredByListId = makeSelectIsFilteredByListId();

export const makeSelectFilteredCardIdsByListId = () =>
  createSelector(
    orm,
    (_, id) => id,
    ({ List }, id) => {
      const listModel = List.withId(id);

      if (!listModel) {
        return listModel;
      }

      return listModel.getFilteredOrderedCardsModelArray().map((cardModel) => cardModel.id);
    },
  );

export const selectFilteredCardIdsByListId = makeSelectFilteredCardIdsByListId();

export const makeSelectNotificationsByListId = () =>
  createSelector(
    orm,
    (_, id) => id,
    ({ List }, id) => {
      if (!id) {
        return id;
      }

      const listModel = List.withId(id);

      if (!listModel) {
        return listModel;
      }

      return listModel.getUnreadNotificationsQuerySet().toRefArray();
    },
  );

export const selectNotificationsByListId = makeSelectNotificationsByListId();

export const makeSelectNotificationsTotalByListId = () =>
  createSelector(
    orm,
    (_, id) => id,
    ({ List }, id) => {
      if (!id) {
        return id;
      }

      const listModel = List.withId(id);

      if (!listModel) {
        return listModel;
      }

      return listModel.getUnreadNotificationsQuerySet().count();
    },
  );

export const selectNotificationsTotalByListId = makeSelectNotificationsTotalByListId();

export default {
  makeSelectListById,
  selectListById,
  makeSelectCardIdsByListId,
  selectCardIdsByListId,
  makeSelectIsFilteredByListId,
  selectIsFilteredByListId,
  makeSelectFilteredCardIdsByListId,
  selectFilteredCardIdsByListId,
  makeSelectNotificationsByListId,
  selectNotificationsByListId,
  makeSelectNotificationsTotalByListId,
  selectNotificationsTotalByListId,
};
